const guides = [
  {
    slug: "blog-image-size",
    tag: "블로그 이미지",
    icon: "↔",
    title: "블로그 이미지, 몇 px로 올려야 선명할까?",
    summary: "무조건 크게 올리는 대신 본문 폭과 원본 비율에 맞춰 선명도와 로딩 속도를 함께 잡는 기준을 정리했습니다.",
    read: "8분",
    published: "2026-07-28",
    updated: "2026-08-30",
    toolPath: "/tools/image-resizer",
    toolLabel: "이미지 크기 조절하기",
    lead: "결론부터 말하면 일반적인 블로그 본문 사진은 긴 변 1200~1600px에서 시작하면 무난합니다. 중요한 것은 숫자 하나를 외우는 게 아니라 실제 표시 폭, 원본 크기, 확대 가능성을 함께 보는 것입니다.",
    experiment: {
      title: "직접 찍은 4160px 사진을 1200px로 줄여봤습니다",
      description: "공개 장소에서 직접 촬영한 같은 사진을 BlogToolTool에서 비율 유지, 가로 1200px, 품질 85%로 변환했습니다. 원본과 결과 파일은 별도로 보관하고 파일 크기를 실제 바이트 기준으로 비교했습니다.",
      images: [
        { src: "/evidence/image-resizer-settings.png", alt: "BlogToolTool 이미지 리사이즈에서 가로 1200픽셀, WebP, 품질 85퍼센트를 설정한 화면", caption: "변환 설정: 1200×675px · WebP · 품질 85%", width: 1483, height: 982 },
        { src: "/evidence/image-resizer-result.png", alt: "BlogToolTool 이미지 리사이즈 변환 완료 후 결과 크기 79킬로바이트가 표시된 화면", caption: "변환 결과: 화면에 79KB로 표시된 실제 결과", width: 1491, height: 1051 }
      ],
      table: { headers: ["파일", "크기", "원본 대비"], rows: [["원본 JPG · 4160×2340", "2.38MB", "100%"], ["WebP · 1200×675 · 85%", "79.0KB", "약 3.2%"], ["JPG · 1200×675 · 85%", "118.4KB", "약 4.9%"]] },
      note: "2026년 8월 30일 Chrome 데스크톱에서 직접 측정했습니다. 사진 내용과 브라우저 인코더에 따라 다른 결과가 나올 수 있으므로 이 수치는 보장값이 아니라 비교 사례입니다."
    },
    sections: [
      { title: "먼저 본문이 실제로 몇 px인지 확인하세요", paragraphs: ["블로그 스킨이 화면 전체를 쓰는 것처럼 보여도 글이 표시되는 본문 영역은 그보다 좁습니다. 700px 폭으로 표시되는 사진을 4000px로 올리면 플랫폼이 다시 줄이고 압축하는 과정에서 용량만 커질 수 있습니다.", "PC 본문 폭을 모르겠다면 긴 변 1200px로 먼저 만들어 모바일과 PC에서 확인하세요. 사진을 눌러 확대해서 보여주는 블로그라면 1600px 정도를 남기고, 확대 기능이 없다면 실제 표시 폭의 약 1.5배로도 충분합니다."] },
      { title: "용도별로 시작하기 좋은 크기", table: { headers: ["용도", "시작 크기", "확인할 점"], rows: [["본문 가로 사진", "긴 변 1200px", "글자나 제품 라벨이 읽히는지"], ["확대가 필요한 사진", "긴 변 1600px", "원본이 이보다 작은지"], ["공유 대표 이미지", "1200 × 630px", "중요 요소가 가운데 있는지"], ["세로형 과정 사진", "가로 900~1200px", "모바일에서 지나치게 길지 않은지"]] } },
      { title: "작은 원본을 억지로 키우면 선명해지지 않습니다", paragraphs: ["가로 700px인 사진을 1400px로 바꾸면 픽셀 수는 늘지만 없던 디테일이 생기지는 않습니다. 오히려 경계가 부드럽게 번져 글자와 선이 흐려질 수 있습니다. 작은 원본은 원래 크기 이하로 사용하거나 더 큰 원본을 다시 확보하는 것이 가장 확실합니다."] },
      { title: "사진과 캡처 화면은 저장 전략이 다릅니다", paragraphs: ["풍경이나 음식 사진처럼 색 변화가 많은 이미지는 JPG나 WebP가 효율적입니다. 반면 게임 공략의 메뉴 화면, 앱 사용법, 표처럼 글자와 직선이 많은 이미지는 압축률을 너무 높이면 글자 주변에 얼룩이 먼저 보입니다."], bullets: ["사진: 품질 82~88에서 시작해 결과를 눈으로 확인", "화면 캡처: 글자 가장자리를 100% 확대해서 확인", "투명 배경 로고: PNG 또는 투명 WebP 사용", "원본 파일: 변환 결과와 별도로 보관"] },
      { title: "업로드 전 30초 체크", bullets: ["원본 비율이 찌그러지지 않았는가", "본문에서 실제로 필요한 크기보다 지나치게 크지 않은가", "작은 글자가 모바일에서도 읽히는가", "파일명이 내용을 설명하는가", "같은 글 안에서 이미지 폭이 들쭉날쭉하지 않은가"] }
    ],
    faq: [
      { q: "무조건 1200px로 맞추면 되나요?", a: "아닙니다. 작은 원본은 확대하지 말고, 세밀한 확대가 필요한 사진은 1600px 이상을 검토하세요. 1200px은 실패가 적은 시작점입니다." },
      { q: "이미 올린 사진이 흐리면 다시 올려야 하나요?", a: "원본 자체가 충분히 크다면 압축 품질을 높여 다시 올리는 편이 좋습니다. 원본이 작다면 재업로드만으로는 개선되지 않습니다." }
    ]
  },
  {
    slug: "gif-optimization",
    tag: "GIF 만들기",
    icon: "GIF",
    title: "화질은 지키고 GIF 용량은 줄이는 순서",
    summary: "길이, 화면 크기, FPS, 색상 중 무엇을 먼저 줄여야 손해가 적은지 작업 순서로 설명합니다.",
    read: "9분",
    published: "2026-07-28",
    updated: "2026-08-01",
    toolPath: "/tools/video-to-gif",
    toolLabel: "동영상을 GIF로 바꾸기",
    lead: "GIF가 너무 크다고 처음부터 화질 슬라이더를 내리면 글자와 색이 먼저 망가집니다. 가장 덜 아픈 순서는 불필요한 시간 자르기, 표시 크기 맞추기, FPS 조절, 마지막으로 색상과 품질 조절입니다.",
    sections: [
      { title: "1단계: 시작과 끝의 멈춘 구간부터 자르세요", paragraphs: ["GIF 용량은 대체로 프레임 수가 늘수록 커집니다. 버튼을 누르기 전 머뭇거리는 1초, 동작이 끝난 뒤 멈춘 2초도 모두 프레임으로 저장됩니다. 설명하려는 동작 하나만 남기는 것이 화질 손실 없이 용량을 줄이는 가장 확실한 방법입니다."] },
      { title: "2단계: 실제 표시 폭에 맞추세요", paragraphs: ["블로그 본문에서 700px로 보여줄 GIF를 1920px로 만들 이유는 거의 없습니다. 화면 녹화라면 글자가 읽히는 최소 폭을 찾고, 게임 장면처럼 전체 움직임이 중요하다면 720~960px부터 비교해 보세요."] },
      { title: "3단계: 내용에 맞는 FPS를 고르세요", table: { headers: ["내용", "시작 FPS", "판단 기준"], rows: [["메뉴·앱 사용법", "8~12", "커서와 버튼 동작이 구분되는가"], ["일반적인 제품 동작", "12~15", "움직임이 끊겨 보이지 않는가"], ["게임·빠른 동작", "15~20", "핵심 장면이 빠지지 않는가"]] } },
      { title: "4단계: 긴 설명은 GIF를 나누세요", paragraphs: ["설치부터 결과까지 한 파일에 모두 넣으면 독자는 기다려야 하고 작성자는 용량을 감당해야 합니다. ‘메뉴 열기’, ‘옵션 선택’, ‘결과 확인’처럼 행동 단위로 나누면 각 GIF의 목적도 선명해집니다."] },
      { title: "마지막에만 품질을 조절하세요", paragraphs: ["길이와 크기, FPS를 조정한 뒤에도 크다면 품질을 한 단계씩 내리면서 글자와 색 경계를 확인하세요. 미리보기의 전체 인상만 보지 말고 작은 글자, 그라데이션, 얼굴처럼 손상이 먼저 보이는 부분을 확대해 비교하는 것이 좋습니다."], bullets: ["원본 영상은 삭제하지 않기", "변환 결과를 실제 블로그 폭에서 확인하기", "같은 설정에서 한 번에 한 항목만 바꾸기", "용량 숫자보다 독자가 이해할 수 있는지를 우선하기"] }
    ],
    faq: [
      { q: "GIF는 몇 초가 적당한가요?", a: "정해진 제한은 없지만 한 동작을 설명하는 3~8초 구간이 관리하기 쉽습니다. 더 길다면 두 개로 나눌 수 있는지 먼저 보세요." },
      { q: "FPS를 높이면 무조건 부드러운가요?", a: "프레임은 늘지만 원본 영상의 FPS보다 높여도 새로운 움직임 정보는 생기지 않습니다. 용량만 커질 수 있습니다." }
    ]
  },
  {
    slug: "watermark-guide",
    tag: "콘텐츠 보호",
    icon: "©",
    title: "사진을 해치지 않는 워터마크 위치와 투명도",
    summary: "도용 방지와 사진 감상을 모두 고려해 위치, 여백, 색상, 문구를 결정하는 방법을 정리했습니다.",
    read: "8분",
    published: "2026-07-28",
    updated: "2026-08-30",
    toolPath: "/tools/watermark",
    toolLabel: "사진에 워터마크 넣기",
    lead: "워터마크는 진하게 넣는다고 무조건 안전하지 않습니다. 모서리에 너무 붙으면 쉽게 잘리고, 중앙을 크게 가리면 원래 사진의 가치가 떨어집니다. 사진의 목적과 도용 위험에 따라 강도를 나누는 편이 낫습니다.",
    experiment: {
      title: "같은 야간 사진에서 위치와 투명도만 바꿨습니다",
      description: "밝은 분수와 어두운 하늘이 함께 있는 직접 촬영 사진을 사용했습니다. 문구와 흰색은 유지하고 위치와 투명도만 바꿔 사진 감상과 출처 표시의 균형을 비교했습니다.",
      images: [
        { src: "/evidence/watermark-corner.png", alt: "야간 분수 사진 오른쪽 아래에 흰색 BlogToolTool 워터마크를 투명도 35퍼센트로 넣은 화면", caption: "오른쪽 아래 · 흰색 · 투명도 35%", width: 1506, height: 1054 },
        { src: "/evidence/watermark-center.png", alt: "야간 분수 사진 가운데에 흰색 BlogToolTool 워터마크를 투명도 25퍼센트로 넣은 화면", caption: "가운데 · 흰색 · 투명도 25%", width: 1513, height: 1050 }
      ],
      table: { headers: ["설정", "장점", "주의점"], rows: [["오른쪽 아래 35%", "사진 감상을 덜 방해", "가장자리와 함께 잘라내기 쉬움"], ["가운데 25%", "잘라 재사용하기 어려움", "주요 피사체를 가릴 수 있음"]] },
      note: "2026년 8월 30일 BlogToolTool 워터마크 도구로 만든 비교입니다. 배경 밝기에 따라 같은 투명도도 다르게 보이므로 최종 이미지를 실제 게시 크기로 확인해야 합니다."
    },
    sections: [
      { title: "일상·리뷰 사진은 모서리 안쪽부터", paragraphs: ["음식, 제품, 여행 사진처럼 감상이 중요한 이미지는 오른쪽 아래 또는 왼쪽 아래가 무난합니다. 가장자리에 딱 붙이지 말고 이미지 너비의 약 3% 정도를 여백으로 두면 모바일에서도 답답해 보이지 않습니다."] },
      { title: "자료 사진은 복사하기 어려운 위치를 고르세요", paragraphs: ["비교표, 공략 위치, 직접 만든 도식처럼 정보 자체가 중요한 이미지는 모서리 워터마크만 잘라 재사용하기 쉽습니다. 핵심 글자를 가리지 않는 범위에서 중앙 가까운 빈 공간에 작게 놓거나, 낮은 투명도의 워터마크를 두 군데 사용하는 방법이 더 실용적입니다."] },
      { title: "투명도는 배경 밝기에 따라 달라집니다", table: { headers: ["배경", "문자색", "시작 투명도"], rows: [["밝은 사진", "검정 또는 짙은 회색", "30~40%"], ["어두운 사진", "흰색", "30~45%"], ["밝기 변화가 큰 사진", "외곽선이 있는 문자", "35~50%"]] } },
      { title: "문구는 짧고 일관되게", paragraphs: ["긴 블로그 주소 전체를 넣기보다 활동명이나 짧은 도메인을 사용하는 편이 읽기 쉽습니다. BlogToolTool처럼 서비스명이 있다면 모든 이미지에서 같은 표기와 비슷한 크기를 유지해야 출처 표시 역할도 합니다."], bullets: ["닉네임과 도메인 중 하나를 기본 문구로 정하기", "사진마다 글꼴을 바꾸지 않기", "저작권 기호만 넣고 출처를 생략하지 않기", "변환 후 원본 파일을 덮어쓰지 않기"] },
      { title: "게시 전 작은 화면에서도 확인하세요", paragraphs: ["PC에서 적당해 보이는 워터마크가 모바일에서는 너무 크거나 흐릿할 수 있습니다. 완성 이미지를 실제 게시 폭으로 줄여 보고, 사진 내용과 출처가 모두 인식되는지 확인한 뒤 저장하세요."] }
    ],
    faq: [
      { q: "워터마크를 넣으면 도용을 완전히 막을 수 있나요?", a: "완전히 막지는 못합니다. 무단 사용의 수고를 높이고 원출처를 알리는 장치로 보는 것이 정확합니다." },
      { q: "블로그 주소와 닉네임 중 무엇이 좋나요?", a: "주소가 자주 바뀌지 않는다면 짧은 도메인이 명확합니다. 개인 활동명을 여러 플랫폼에서 함께 쓴다면 닉네임이 더 알아보기 쉽습니다." }
    ]
  },
  {
    slug: "jpg-png-webp",
    tag: "이미지 포맷",
    icon: "JPG",
    title: "JPG·PNG·WebP, 블로그 사진은 무엇으로 저장할까?",
    summary: "사진, 화면 캡처, 투명 로고별로 포맷을 고르고 잘못 변환했을 때 생기는 문제까지 설명합니다.",
    read: "9분",
    published: "2026-08-01",
    updated: "2026-08-01",
    toolPath: "/tools/image-resizer",
    toolLabel: "이미지 포맷 바꾸기",
    lead: "정답은 이미지의 내용에 따라 달라집니다. 사진은 JPG나 WebP, 투명 배경과 날카로운 선이 중요한 이미지는 PNG가 기본입니다. 확장자만 바꾼다고 화질이 좋아지지는 않는다는 점도 중요합니다.",
    sections: [
      { title: "사진은 JPG 또는 WebP부터 비교하세요", paragraphs: ["카메라 사진은 픽셀마다 색이 조금씩 달라 무손실 PNG로 저장하면 용량이 크게 늘어납니다. JPG는 호환성이 넓고 결과를 예측하기 쉽습니다. WebP는 같은 용도에서 더 작은 파일을 만들기 유리하지만 게시할 플랫폼이 WebP 업로드와 노출을 제대로 지원하는지 먼저 확인하세요."] },
      { title: "PNG가 필요한 순간", paragraphs: ["로고, 아이콘, 단순한 도식, 투명 배경 상품 컷은 PNG가 안전합니다. 특히 투명 영역이 있는 이미지를 JPG로 저장하면 투명 부분이 흰색이나 검은색 배경으로 바뀝니다."], bullets: ["투명 배경이 필요하다", "작은 글자와 직선이 많다", "색상 수가 적은 도식이다", "편집 중간 결과를 손실 없이 보관한다"] },
      { title: "화면 캡처는 내용에 따라 선택하세요", paragraphs: ["게임 화면처럼 사진에 가까운 캡처는 JPG나 WebP로 줄이기 좋습니다. 설정 메뉴나 코드 화면처럼 글자가 중심이면 PNG가 더 또렷할 수 있습니다. 결국 전체 화면이 아니라 작은 글자 가장자리를 확대해 비교해야 합니다."] },
      { title: "포맷별 선택표", table: { headers: ["이미지", "우선 선택", "대안"], rows: [["일반 사진", "WebP", "JPG"], ["호환성이 가장 중요", "JPG", "PNG"], ["투명 로고", "PNG", "투명 WebP"], ["글자 많은 캡처", "PNG", "고품질 WebP"], ["원본 보관", "원본 형식", "무손실 PNG"]] } },
      { title: "재변환을 반복하지 마세요", paragraphs: ["낮은 품질의 JPG를 다시 고품질 JPG로 저장해도 손실된 정보는 돌아오지 않습니다. 게시용 결과는 항상 원본에서 새로 만들고, 결과 파일명에 크기나 용도를 표시해 원본과 섞이지 않게 관리하세요."] }
    ],
    faq: [
      { q: "PNG를 JPG로 바꾸면 항상 작아지나요?", a: "사진은 대체로 작아지지만 단순한 로고나 도식은 오히려 이점이 작고 투명 배경을 잃게 됩니다." },
      { q: "WebP면 무조건 화질이 더 좋은가요?", a: "아닙니다. 포맷보다 저장 품질 설정과 원본 상태가 중요합니다. 같은 화면 크기와 비슷한 체감 화질에서 용량을 비교해야 합니다." }
    ]
  },
  {
    slug: "resize-without-blur",
    tag: "이미지 리사이즈",
    icon: "1:1",
    title: "이미지 리사이즈 후 흐려지는 이유와 해결 순서",
    summary: "비율 왜곡, 작은 원본 확대, 반복 압축, 글자 번짐을 구분해 원인별로 해결합니다.",
    read: "8분",
    published: "2026-08-01",
    updated: "2026-08-01",
    toolPath: "/tools/image-resizer",
    toolLabel: "선명하게 크기 조절하기",
    lead: "리사이즈 뒤 흐려졌다면 품질 수치만 올리기 전에 원본 크기와 가로세로 비율을 확인해야 합니다. 원인에 따라 품질 설정으로 해결되지 않는 경우가 더 많습니다.",
    sections: [
      { title: "원본보다 크게 만들었는지 확인", paragraphs: ["가로 600px 이미지를 1200px로 확대하면 브라우저가 주변 픽셀을 참고해 중간 값을 채웁니다. 사진은 부드럽게 보이고 작은 글자는 번질 수 있습니다. 원본이 작다면 목표 크기를 낮추거나 원본을 다시 구하는 것이 먼저입니다."] },
      { title: "가로세로 비율을 잠그세요", paragraphs: ["예를 들어 4:3 사진을 강제로 16:9 크기에 맞추면 사람 얼굴과 원형 물체가 눌립니다. 원하는 프레임 비율이 다르다면 찌그러뜨리지 말고 일부를 잘라내거나 여백을 추가해야 합니다."] },
      { title: "리사이즈와 압축을 나눠 판단하세요", table: { headers: ["보이는 문제", "가능한 원인", "먼저 할 일"], rows: [["전체가 부드러움", "원본 확대", "목표 크기 낮추기"], ["사물이 납작함", "비율 강제 변경", "비율 잠금"], ["글자 주변 얼룩", "과한 손실 압축", "품질 높이기 또는 PNG"], ["업로드 후만 흐림", "플랫폼 재압축", "업로드 크기 조정"]] } },
      { title: "한 번의 변환으로 끝내세요", paragraphs: ["메신저로 받은 압축본을 편집하고 다시 저장한 뒤 블로그가 또 압축하면 손실이 누적됩니다. 가능한 한 카메라 원본이나 최초 캡처에서 목표 크기와 포맷을 한 번에 정하세요."] },
      { title: "결과 확인은 100%와 게시 크기 두 번", paragraphs: ["100% 확대에서는 글자 경계와 압축 얼룩을 찾고, 실제 게시 크기에서는 전체 인상과 가독성을 봅니다. 둘 중 하나만 보면 필요 이상으로 큰 파일을 만들거나 작은 결함을 놓치기 쉽습니다."] }
    ],
    faq: [
      { q: "선명하게 만드는 옵션은 없나요?", a: "약한 샤픈은 도움될 수 있지만 작은 원본에 없던 디테일을 복구하지는 못합니다. 원본 확보가 우선입니다." },
      { q: "품질 100으로 저장하면 해결되나요?", a: "압축 손실은 줄지만 비율 왜곡이나 확대에 따른 흐림은 해결되지 않고 파일만 커질 수 있습니다." }
    ]
  },
  {
    slug: "og-image-1200-630",
    tag: "대표 이미지",
    icon: "OG",
    title: "1200×630 대표 이미지에서 제목이 잘리지 않게 만드는 법",
    summary: "공유 카드 비율의 안전 영역, 글자 크기, 모바일 미리보기까지 실전 제작 기준을 안내합니다.",
    read: "7분",
    published: "2026-08-01",
    updated: "2026-08-01",
    toolPath: "/tools/image-resizer",
    toolLabel: "1200×630 이미지 만들기",
    lead: "1200×630은 웹 공유 카드에 널리 쓰기 좋은 1.91:1 비율입니다. 하지만 서비스마다 가장자리를 조금씩 자르거나 작은 썸네일로 축소하므로 핵심 문구를 테두리 가까이 두면 안 됩니다.",
    sections: [
      { title: "중요한 내용은 가운데 안전 영역에", paragraphs: ["제목, 로고, 얼굴처럼 반드시 보여야 하는 요소는 사방 가장자리에서 충분히 띄우세요. 실무적으로는 좌우 약 100px, 위아래 약 60px 안쪽을 안전 영역으로 생각하면 다양한 미리보기에 대응하기 쉽습니다. 이는 절대 규칙이 아니라 잘림을 줄이는 제작 여유입니다."] },
      { title: "제목을 이미지에 전부 적지 마세요", paragraphs: ["긴 글 제목을 그대로 넣으면 모바일 썸네일에서 읽을 수 없을 정도로 작아집니다. 핵심 단어와 결론만 1~2줄로 줄이고, 전체 제목은 페이지의 HTML 제목이 담당하게 하세요."] },
      { title: "구성 순서", bullets: ["배경 사진 또는 단색 영역 선택", "핵심 제목을 1~2줄로 축약", "제목과 배경 사이 명암 대비 확보", "로고나 카테고리는 보조 크기로 배치", "작은 미리보기로 줄여 가독성 확인"] },
      { title: "사진을 억지로 늘리지 말고 잘라내세요", paragraphs: ["세로 사진을 1200×630에 강제로 맞추면 피사체가 옆으로 늘어납니다. 비율을 유지한 채 가운데나 관심 영역을 기준으로 잘라내고, 잘라낼 수 없다면 흐린 배경이나 단색 여백 위에 사진을 배치하세요."] },
      { title: "파일 크기보다 먼저 확인할 것", table: { headers: ["확인 항목", "통과 기준"], rows: [["제목", "작은 화면에서도 한눈에 읽힘"], ["대비", "배경과 글자가 분리됨"], ["안전 영역", "핵심 요소가 가장자리와 떨어짐"], ["왜곡", "사람과 원형이 정상 비율"], ["파일명", "글 주제를 설명함"]] } }
    ],
    faq: [
      { q: "항상 정확히 1200×630이어야 하나요?", a: "반드시 그런 것은 아니지만 공유용 가로 이미지의 안정적인 시작점입니다. 사용하는 플랫폼의 최신 미리보기를 직접 확인하세요." },
      { q: "이미지 안의 글자가 검색에 도움이 되나요?", a: "이미지 속 글자만으로는 충분하지 않습니다. 페이지 제목, 본문, 대체 텍스트에서도 내용을 명확하게 설명해야 합니다." }
    ]
  },
  {
    slug: "gif-fps-guide",
    tag: "GIF 프레임",
    icon: "FPS",
    title: "GIF FPS는 10·15·20 중 무엇을 골라야 할까?",
    summary: "메뉴 설명과 게임 장면은 필요한 프레임이 다릅니다. 움직임별 선택 기준을 사례로 정리했습니다.",
    read: "8분",
    published: "2026-08-01",
    updated: "2026-08-30",
    toolPath: "/tools/video-to-gif",
    toolLabel: "FPS를 골라 GIF 만들기",
    lead: "FPS는 1초에 보여주는 장면 수입니다. 높을수록 움직임이 촘촘해지지만 프레임과 용량도 늘어납니다. 블로그용 GIF는 영화처럼 부드러운 것보다 설명할 동작이 빠지지 않는지가 중요합니다.",
    experiment: {
      title: "같은 3초 구간에서 10 FPS와 20 FPS를 비교했습니다",
      description: "직접 촬영한 1080×1920 세로 영상을 3.0초부터 6.0초까지 선택하고 출력 크기 50%를 유지했습니다. 다른 조건은 그대로 두고 FPS만 바꿔 실제 GIF 결과 용량을 비교했습니다.",
      images: [
        { src: "/evidence/gif-10fps-settings.png", alt: "BlogToolTool GIF 변환기에서 3초 구간, 10 FPS, 출력 크기 50퍼센트를 설정한 화면", caption: "10 FPS · 약 30프레임 · 출력 50%", width: 1540, height: 1105 },
        { src: "/evidence/gif-10fps-result.png", alt: "10 FPS GIF 변환 결과가 540 곱하기 960픽셀과 5.91메가바이트로 표시된 화면", caption: "10 FPS 결과 · 540×960px · 5.91MB", width: 1522, height: 1012 },
        { src: "/evidence/gif-20fps-settings.png", alt: "BlogToolTool GIF 변환기에서 같은 3초 구간과 크기에 20 FPS를 설정한 화면", caption: "20 FPS · 약 60프레임 · 출력 50%", width: 1506, height: 1083 },
        { src: "/evidence/gif-20fps-result.png", alt: "20 FPS GIF 변환 결과가 540 곱하기 960픽셀과 11.81메가바이트로 표시된 화면", caption: "20 FPS 결과 · 540×960px · 11.81MB", width: 1494, height: 985 }
      ],
      table: { headers: ["조건", "프레임", "결과 크기", "파일 크기"], rows: [["10 FPS", "약 30", "540×960px", "5.91MB"], ["20 FPS", "약 60", "540×960px", "11.81MB"]] },
      note: "2026년 8월 30일 Chrome 데스크톱에서 직접 측정했습니다. 이 장면에서는 FPS를 두 배로 높이자 파일도 약 2배가 됐지만, 영상 내용과 압축 효율에 따라 항상 정확히 같은 비율로 증가하지는 않습니다."
    },
    sections: [
      { title: "10 FPS: 메뉴와 단계 설명", paragraphs: ["설정 메뉴 열기, 버튼 위치 안내, 짧은 웹 사용법은 8~10 FPS에서도 이해하기 쉽습니다. 커서 이동이 조금 끊겨 보여도 클릭 전후 상태가 분명하면 설명 목적은 달성됩니다."] },
      { title: "15 FPS: 가장 무난한 출발점", paragraphs: ["손동작, 제품 작동, 일반적인 게임 메뉴처럼 움직임과 정보가 함께 있는 장면은 12~15 FPS가 균형 잡힌 시작점입니다. 판단이 어렵다면 15로 먼저 만들고 용량이 크면 12나 10으로 내려보세요."] },
      { title: "20 FPS: 빠른 움직임을 짧게", paragraphs: ["게임 전투, 빠른 제스처, 공이 움직이는 장면은 18~20 FPS에서 핵심 순간을 더 잘 보존할 수 있습니다. 대신 구간을 짧게 자르고 화면 크기를 먼저 줄여야 용량 증가를 감당하기 쉽습니다."] },
      { title: "선택표", table: { headers: ["장면", "추천 시작값", "우선 조절"], rows: [["앱·웹 메뉴", "10 FPS", "구간 길이"], ["제품 사용법", "15 FPS", "화면 크기"], ["게임 UI", "12~15 FPS", "글자 가독성"], ["빠른 게임 장면", "18~20 FPS", "짧은 구간"]] } },
      { title: "같은 3초 구간으로 비교하세요", paragraphs: ["10 FPS와 20 FPS를 비교할 때 구간과 크기, 품질을 모두 같게 유지해야 FPS 차이만 볼 수 있습니다. 파일 용량과 함께 움직임이 실제 설명에 도움이 되는지도 확인하세요. 차이를 거의 못 느낀다면 낮은 쪽이 효율적입니다."] }
    ],
    faq: [
      { q: "원본이 60 FPS면 GIF도 60으로 해야 하나요?", a: "블로그용 GIF에서는 대개 필요하지 않습니다. 용량이 매우 커지고 GIF 형식의 색상 한계 때문에 효율도 낮습니다." },
      { q: "FPS를 낮추면 재생 시간이 바뀌나요?", a: "정상적으로 변환하면 전체 시간은 유지되고 초당 표시되는 프레임 수만 줄어듭니다." }
    ]
  },
  {
    slug: "gif-blurry-fix",
    tag: "GIF 문제 해결",
    icon: "FIX",
    title: "GIF가 흐리거나 색이 깨질 때 확인할 6가지",
    summary: "원본 확대, 색상 수, 압축, 플랫폼 재처리를 구분해 시행착오를 줄이는 점검 순서입니다.",
    read: "9분",
    published: "2026-08-01",
    updated: "2026-08-01",
    toolPath: "/tools/video-to-gif",
    toolLabel: "GIF 다시 변환하기",
    lead: "GIF는 표현할 수 있는 색이 제한적인 형식이라 영상과 똑같이 보이지 않습니다. 특히 그라데이션, 어두운 장면, 작은 글자에서 손상이 먼저 드러납니다. 문제 모양을 보면 원인을 좁힐 수 있습니다.",
    sections: [
      { title: "1. 원본보다 크게 만들지 않았는지", paragraphs: ["작은 영상을 확대해 GIF로 만들면 모든 프레임이 흐려집니다. 변환 전 원본 해상도를 확인하고 목표 크기를 원본 이하로 유지하세요."] },
      { title: "2. 글자가 뭉개지면 화면 크기부터", paragraphs: ["품질을 올리기 전에 GIF 폭이 글자를 읽기에 충분한지 확인하세요. 메뉴 화면을 너무 작게 줄이면 어떤 품질 설정도 작은 글자를 되살릴 수 없습니다. 핵심 영역만 잘라 크게 보여주는 편이 낫습니다."] },
      { title: "3. 그라데이션 줄무늬는 색상 한계", paragraphs: ["하늘, 그림자, 반투명 효과처럼 색이 천천히 변하는 영역은 GIF에서 띠처럼 나뉠 수 있습니다. 디더링은 경계를 덜 눈에 띄게 하지만 거친 점무늬와 용량 증가가 생길 수 있으므로 원본 장면을 바꾸거나 WebM·MP4 사용도 고려해야 합니다."] },
      { title: "4. 업로드 전후 결과를 비교", table: { headers: ["상태", "가능성", "대응"], rows: [["로컬 파일부터 흐림", "변환 설정", "크기·품질 재조정"], ["업로드 후만 흐림", "플랫폼 재처리", "폭·용량 낮춰 재시험"], ["특정 색만 깨짐", "GIF 색상 제한", "장면 단순화·다른 형식"], ["움직임만 끊김", "낮은 FPS", "FPS 한 단계 상승"]] } },
      { title: "5. 한 항목씩 바꾸세요", paragraphs: ["크기, FPS, 품질을 한꺼번에 바꾸면 무엇이 효과가 있었는지 알 수 없습니다. 같은 짧은 구간으로 기준 파일을 만들고 크기부터, 다음 FPS, 마지막 품질 순서로 하나씩 비교하세요."] },
      { title: "6. GIF가 맞는 형식인지 다시 판단", paragraphs: ["긴 영상, 사진 같은 색감, 소리, 20 FPS 이상의 부드러운 움직임이 중요하다면 GIF보다 MP4나 WebM이 적합합니다. GIF는 짧고 반복되는 설명 장면에서 가장 강합니다."] }
    ],
    faq: [
      { q: "GIF 색상을 원본과 완전히 같게 만들 수 있나요?", a: "복잡한 영상에서는 어렵습니다. GIF의 색 표현 한계 때문에 장면에 따라 다른 형식을 선택하는 것이 더 낫습니다." },
      { q: "디더링은 항상 켜는 게 좋은가요?", a: "그라데이션에는 도움이 되지만 단순한 UI에서는 글자 주변이 거칠어질 수 있습니다. 장면별 비교가 필요합니다." }
    ]
  },
  {
    slug: "transparent-image-format",
    tag: "투명 이미지",
    icon: "α",
    title: "투명 배경 이미지가 검게 보이거나 깨지는 이유",
    summary: "PNG·WebP의 알파 채널, JPG 변환, 가장자리 테두리 문제를 구분해 해결합니다.",
    read: "7분",
    published: "2026-08-01",
    updated: "2026-08-01",
    toolPath: "/tools/image-resizer",
    toolLabel: "투명 이미지 변환하기",
    lead: "투명 배경은 흰색 배경이 아니라 픽셀마다 투명도를 저장한 상태입니다. 이 정보를 지원하지 않는 형식으로 바꾸거나 어두운 배경에서 확인하면 예상과 다른 결과가 나타납니다.",
    sections: [
      { title: "JPG는 투명 배경을 저장하지 못합니다", paragraphs: ["투명 PNG를 JPG로 바꾸는 순간 빈 영역은 특정 배경색으로 채워져야 합니다. 보통 흰색이지만 도구나 처리 과정에 따라 검게 보일 수도 있습니다. 투명이 필요하면 PNG 또는 투명도를 지원하는 WebP를 선택하세요."] },
      { title: "흰 테두리는 이전 배경색의 흔적일 수 있습니다", paragraphs: ["흰 배경에서 잘라낸 로고 가장자리에는 반투명한 흰색 픽셀이 남을 수 있습니다. 밝은 화면에서는 자연스럽지만 어두운 배경에서는 흰 테두리처럼 드러납니다. 처음부터 투명 배경을 기준으로 가장자리를 다듬은 원본이 필요합니다."] },
      { title: "체커보드와 실제 배경을 구분하세요", paragraphs: ["편집 화면의 회색 체크무늬는 투명 영역을 보여주는 표시일 뿐 이미지에 포함된 무늬가 아닙니다. 저장한 파일을 흰색과 검은색 배경 모두에 올려 가장자리와 그림자를 확인하세요."] },
      { title: "용도별 선택", table: { headers: ["용도", "형식", "확인"], rows: [["로고·아이콘", "PNG", "어두운 배경 테두리"], ["투명 상품 사진", "PNG 또는 WebP", "게시 플랫폼 지원"], ["흰 배경 사진", "JPG 또는 WebP", "투명 필요 여부"], ["편집 원본", "PNG", "원본 별도 보관"]] } },
      { title: "업로드 플랫폼이 변환할 수도 있습니다", paragraphs: ["내 컴퓨터에서는 투명한데 게시 후 배경이 생긴다면 플랫폼이 이미지를 다른 형식으로 바꿨을 가능성이 있습니다. 작은 테스트 이미지를 먼저 올리고 실제 게시 화면에서 투명이 유지되는지 확인하세요."] }
    ],
    faq: [
      { q: "PNG인데 배경이 흰색입니다", a: "파일 자체에 흰 배경이 들어 있거나 보는 프로그램이 투명을 흰색으로 표시할 수 있습니다. 편집기에서 알파 채널을 확인하세요." },
      { q: "투명 WebP가 모든 곳에서 되나요?", a: "현대 브라우저 지원은 넓지만 업로드 서비스가 자체 변환할 수 있습니다. 최종 게시 플랫폼에서 시험하는 것이 안전합니다." }
    ]
  },
  {
    slug: "photo-metadata-privacy",
    tag: "사진 개인정보",
    icon: "EXIF",
    title: "사진 올리기 전 EXIF 위치정보를 확인해야 하는 이유",
    summary: "촬영 위치와 시간, 기기 정보가 사진에 남는 방식과 게시 전 확인 습관을 정리했습니다.",
    read: "8분",
    published: "2026-08-01",
    updated: "2026-08-01",
    toolPath: "/tools/image-resizer",
    toolLabel: "게시용 사본 만들기",
    lead: "스마트폰 사진에는 촬영 시각, 기기 정보, 방향과 함께 위치정보가 기록될 수 있습니다. 플랫폼이 이를 제거해 주는 경우도 있지만 모든 서비스와 다운로드 경로가 같다고 가정하면 안 됩니다.",
    sections: [
      { title: "EXIF에는 무엇이 들어가나", paragraphs: ["EXIF는 사진 촬영 조건을 저장하는 메타데이터입니다. 카메라 모델, 촬영 시각, 회전 방향, 노출 정보가 대표적이고 위치 기록을 허용했다면 GPS 좌표가 포함될 수 있습니다. 사진 화면에 보이지 않아도 파일 안에는 남아 있을 수 있습니다."] },
      { title: "특히 조심할 사진", bullets: ["집이나 어린이집처럼 반복적으로 방문하는 장소", "차량 번호나 출입증이 함께 보이는 사진", "촬영 직후 원본 파일을 직접 배포하는 경우", "중고 거래나 커뮤니티에 원본을 첨부하는 경우", "가족의 생활 동선이 드러나는 연속 사진"] },
      { title: "게시 전 점검 순서", paragraphs: ["먼저 휴대전화 카메라의 위치 저장 설정을 확인합니다. 이미 촬영한 사진은 운영체제의 사진 정보 화면에서 위치를 보고 필요하면 삭제하세요. 게시용으로 크기를 조절한 사본을 만들고, 원본 대신 사본을 업로드하면 실수 가능성을 줄일 수 있습니다."] },
      { title: "메타데이터 제거만으로 끝나지 않습니다", paragraphs: ["간판, 창밖 풍경, 택배 송장, 차량 번호처럼 사진에 직접 찍힌 정보는 EXIF를 지워도 남습니다. 확대해서 모서리까지 확인하고 필요한 부분은 자르거나 가린 뒤 게시하세요."] },
      { title: "원본과 게시용 파일을 분리하세요", table: { headers: ["파일", "보관 목적", "권장 처리"], rows: [["촬영 원본", "추억·재편집", "개인 저장소에 보관"], ["편집본", "추가 수정", "메타데이터 확인"], ["게시용 사본", "블로그 업로드", "크기 조절·민감정보 점검"]] } }
    ],
    faq: [
      { q: "블로그가 자동으로 위치정보를 지워주지 않나요?", a: "서비스마다 처리 방식이 다르고 바뀔 수 있습니다. 업로드 전에 사용자가 직접 확인하는 습관이 가장 안전합니다." },
      { q: "이미지 크기를 줄이면 EXIF가 반드시 없어지나요?", a: "도구와 저장 방식에 따라 다릅니다. 리사이즈만으로 제거된다고 가정하지 말고 결과 파일의 정보를 확인하세요." }
    ]
  }
];

const guideMap = Object.fromEntries(guides.map((guide) => [guide.slug, guide]));

module.exports = { guides, guideMap };
